const RESET_MESSAGE = 'tube/RESET_MESSAGE';
const SET_MESSAGE = 'tube/SET_MESSAGE';

export default function reducer(state = {
  message: undefined,
  onConfirm: undefined,
  onCancel: undefined,
  onClose: undefined,
}, action) {
  switch (action.type) {
    case SET_MESSAGE:
      return Object.assign({}, state, action.props);
    case RESET_MESSAGE:
      return Object.assign({}, state, {
        message: undefined,
        onConfirm: undefined,
        onCancel: undefined,
        onClose: undefined,
      });
    default:
      return state;
  }
}

export function setMessage(props) {
  return {
    type: SET_MESSAGE,
    props,
  };
}

export function resetMessage() {
  return {
    type: RESET_MESSAGE,
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/reducers/messageReducer.js
 **/